<template>

     <v-dialog v-model="dialogurunDetay" persistent width="400px">
            <v-card color="white">
            <v-card-title> <span class=" grey--text font-weight- subheading">
                            {{$t('Remaining-Monthly-Amount-of-Usage')}} </span></v-card-title>
<v-card-text>
   
    <v-container class="bg-surface-variant"> 
    <v-layout row wrap> 
    <v-col>
     <v-divider></v-divider>
    <div><strong>Bilet Adet:</strong> <div class="text-right">{{ this.BiletKontor2 }} </div>  </div>
    <div class="text-right w-100"><strong>Void Adet:</strong> <div> {{ this.VoidKontor2 }}</div> </div>
    <div><strong>İade Adet:</strong> <div>{{ this.IadeKontor2 }} </div></div>
    <div><strong>Coper Adet:</strong><div> {{ this.CoperKontor2 }}</div> </div>
    <div><strong>Coper İptal Adet:</strong><div>{{ this.CoperIptalKontor2 }} </div> </div>
    <div><strong>Vize Adet:</strong><div>{{ this.VizeKontor2 }} </div> </div>
    <div><strong>Cari Adet:</strong><div>{{ this.CariKontor2 }} </div> </div>
    <div><strong>Serbest Fatura Adet:</strong> <div>{{ this.FaturaKontor2 }} </div></div>
    <div><strong>Ek Kontör Sayısı:</strong><div>{{ this.EkKontorSayisi2 }} </div> </div>
    <v-divider></v-divider>
   </v-col>
       
</v-layout>
<v-layout row wrap>
                                <span class=" red--text font-weight- caption"> &nbsp; {{$t('package-limits-need-to-buy')}}
                                     </span>
                            </v-layout>
</v-container>
       
         
           
           
            <div> <v-spacer></v-spacer>  <v-btn color="info" flat @click.native="dialogurunDetay=false">{{$t('Close')}}</v-btn></div>
</v-card-text>
           </v-card>
        
        </v-dialog>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {

    },
    beforeMount: beforeMount,
    

    methods: {
     


      open() {
       
       

            var t = JSON.parse(window.localStorage.getItem('kontorBilgileri'));
            this.BiletKontor2=t.BiletKontor;
            this.CariKontor2=t.CariKontor;
            this.CoperIptalKontor2=t.CoperIptalKontor;
            this.CoperKontor2=t.CoperKontor;
            this.FaturaKontor2=t.FaturaKontor;
            this.IadeKontor2=t.IadeKontor;
            this.VizeKontor2=t.VizeKontor;
            this.VoidKontor2=t.VoidKontor;
            this.EkKontorSayisi2=t.EkKontorSayisi;
           
            
           
           this.dialogurunDetay = true;

      },
    },
    data() {
      return {
            BiletKontor2:0,
            CariKontor2:0,
            CoperIptalKontor2:0,
            CoperKontor2:0,
            FaturaKontor2:0,
            IadeKontor2:0,
            VizeKontor2:0,
            VoidKontor2:0,
            EkKontorSayisi2:0,
            dialogurunDetay:false
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>